import React from "react";
import "./Button.scss";

export default function Button({ text, className, href, newTab, asButton }) {
  return (
    <div className={className}>
      {asButton ? (
        <button className="main-button" type="button">{text}</button>
      ) : (
          <a className="main-button" href={href} target={newTab && "_blank"}>
            {text}
          </a>
      )}
    </div>
  );
}
